import { BackIcon, Button, Card, cn } from "@au-schein-de/au-ui-library";
import type { ProductNoEdibleInfo } from "@dransay/api";
import type { MouseEvent } from "react";
import { ProductImage } from "~/components/product-image.component";
import {
	type BadgeType,
	getNewBadge,
	getProductBadges,
} from "./card/product-card-badges";

type ProductDetailsHeaderProps = {
	product: ProductNoEdibleInfo;
	badges: BadgeType[];
	backLabel: string;
	onBack: (e: MouseEvent<unknown>) => void;
};

export function ProductDetailsHeader({
	product,
	badges,
	backLabel,
	onBack,
}: ProductDetailsHeaderProps) {
	const { imageUrl, name } = product;
	const badgeComponents = getProductBadges(product, badges);
	const newBadge = getNewBadge(product);

	const isOutOfStock = product.isOutOfStock;

	return (
		<Card.Root className="flex justify-center md:col-span-1">
			<div className="hidden md:block absolute md:top-10 md:left-10 z-2">
				<Button
					asChild
					variant="ghost"
					size="md"
					leftIcon={<BackIcon size={6} />}
					className="px-0"
					onClick={onBack}
				>
					{backLabel}
				</Button>
			</div>

			{badgeComponents.length > 0 && !isOutOfStock && (
				<div className="absolute top-4 left-4 md:top-auto md:bottom-10 md:left-10 z-2">
					{badgeComponents}
				</div>
			)}

			{newBadge && !isOutOfStock && (
				<div className="absolute top-4 md:top-10 right-4 md:right-10 z-2">
					{newBadge}
				</div>
			)}

			<ProductImage
				src={imageUrl}
				alt={name ?? ""}
				viewport="productPage"
				fetchPriority="high"
				loading="eager"
				className={cn(
					"max-w-full max-h-full object-scale-down",
					isOutOfStock && "grayscale",
				)}
			/>
		</Card.Root>
	);
}
